import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@mono-repo/util';
import { LoadingIndicatorService } from '@mono-repo/loader';
import { MessageService } from '@mono-repo/messages';
import { PageContainer } from '../../cockpit/_shared/page-container/page-container';
import { HeaderService } from '../../cockpit/_shared/header/header.service';
import { MailingService2 } from '@mono-repo/complex-components';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-request-password',
  templateUrl: './request-password.component.html',
})
export class RequestPasswordComponent extends PageContainer implements OnInit {
  @HostBinding('class') class = 'dt-c-interactive-dialog';

  public emailForm: FormGroup; // think about this: using a formgroup for just one formcontrol is unnecassary
  public passwordRequested = false;
  public pageSubheading: string;
  public hasFocus = false; // This should be refactored to use the e-mail-input-field component, instead of itself implementing has-focus etc.

  constructor(
    private router: Router,
    private loaderService: LoadingIndicatorService,
    headerService: HeaderService,
    translateService: TranslateService,
    private mailingService2: MailingService2,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private configService: ConfigService
  ) {
    super(headerService, translateService);
  }

  ngOnInit() {
    this.setHeaderData({
      hideReporterButton: true,
    });
    this.setTranslateModule('requestPassword');
    this.pageSubheading = this.translateService.translate('PAGE_SUBHEADING');

    this.emailForm = this.formBuilder.group({ email: ['', Validators.email] });
  }

  public backToLogin() {
    this.router.navigateByUrl(`/${this.configService.getConfig().initialRoute}`);
  }

  public submitPasswordRequest() {
    this.loaderService.preactivateLoader();
    this.mailingService2.requestMailForPasswordChange(this.emailForm.value.email).subscribe(
      () => {
        console.warn('successfully requested password reset');
        this.passwordRequested = true;
      },
      () => {
        // error message is handled by odata service
        //this.messageService.add(error, MessageType.ERROR);
      },
    );
  }

  public focusFunction(): void {
    // This should be refactored to use the e-mail-input-field component, instead of itself implementing has-focus etc.
    this.hasFocus = true;
  }

  public focusOutFunction(): void {
    // This should be refactored to use the e-mail-input-field component, instead of itself implementing has-focus etc.
    this.hasFocus = false;
  }
}
